import React from 'react';
import { useIntl } from 'react-intl';

import Panel from '@ts-core/components/Panel/Panel';
import SubjectsTree, { useSubjectsTree } from '@ts-core/modules/subjects/components/SubjectsTree';
import Typography from '@ts-core/components/Typography';
import { CoreSubject } from '@ts-core/modules/subjects/types';

import AvailableExercisesList from './AvailableExercisesList';

import { Subject } from 'modules/subjects/types';
import { Exercise } from 'modules/exercises/types';

export interface AvailableExercisesPanelProps {
  subjects?: Subject[];
  loadingSubjects?: boolean;

  isExerciseSelected: (exercise: Exercise) => boolean;

  onAddExercise: (exercise: Exercise) => void;
  onAddExercises: (exercises: Exercise[]) => void;

  onRemoveExercise: (exercise: Exercise) => void;
}

const AvailableExercisesPanel = (props: AvailableExercisesPanelProps) => {
  const { subjects, loadingSubjects, isExerciseSelected, onAddExercise, onAddExercises, onRemoveExercise } = props;
  const { isSubjectOpen, onToggleSubject } = useSubjectsTree({ subjects });
  const intl = useIntl();

  return (
    <Panel>
      <Typography variant="subtitle2">{intl.formatMessage({ id: 'assignment.availableExercises' })}</Typography>
      <SubjectsTree
        subjects={subjects}
        loading={loadingSubjects}
        isSubjectOpen={isSubjectOpen}
        onClickSubject={onToggleSubject}
        renderSubjectContent={(subject: CoreSubject) => (
          <AvailableExercisesList
            subject={subject}
            isExerciseSelected={isExerciseSelected}
            onAddExercise={onAddExercise}
            onAddExercises={onAddExercises}
            onRemoveExercise={onRemoveExercise}
          />
        )}
      />
    </Panel>
  );
};

export default AvailableExercisesPanel;
